export const processDisbursementHeadings = [
  {
    label: "Sr",
    align: "left",
  },
  {
    label: "Folio",
    align: "left",
  },
  {
    label: "Name",
    align: "left",
  },
  {
    label: "Holding",
    align: "right",
  },
  {
    label: "Gross Dividend",
    align: "right",
  },
  {
    label: "ROC Rate",
    align: "right",
  },
  {
    label: "ROC Amount",
    align: "right",
  },
  {
    label: "ROC Units",
    align: "right",
  },

  {
    label: "Taxable Dividend",
    align: "right",
  },
  {
    label: "Tax Rate",
    align: "right",
  },
  {
    label: "Tax Amount",
    align: "right",
  },
  {
    label: "Net Dividend",
    align: "right",
  },
  {
    label: "Encash",
    align: "right",
  },
  {
    label: "Reinv",
    align: "right",
  },
  {
    label: "Reinv Units",
    align: "right",
  },
];

export const stockmarketPortfolioHeadings = [
  {
    label: "Symbol",
    align: "left",
  },
  {
    label: "Market",
    align: "left",
  },
  {
    label: "Total Units",
    align: "right",
  },
  {
    label: "Available Units",
    align: "right",
  },
  {
    label: "Average Cost / Unit",
    align: "right",
  },
  {
    label: "Total Cost / Amount",
    align: "right",
  },
  {
    label: "Market Rate/Unit",
    align: "right",
  },
  {
    label: "Market Value",
    align: "right",
  },
  {
    label: "Unrealized Gain/(Loss)",
    align: "right",
  },
  {
    label: "Investment as % Market Value",
    align: "right",
  },
];

export const moneymarketPortfolioHeadings = [
  {
    label: "Symbol",
    align: "left",
  },
  {
    label: "Security Type",
    align: "left",
  },
  {
    label: "Name",
    align: "left",
  },
  {
    label: "Issue Date",
    align: "left",
  },
  {
    label: "Maturity Date",
    align: "left",
  },
  {
    label: "Coupon Rate %",
    align: "right",
  },
  {
    label: "Yield %",
    align: "right",
  },
  {
    label: "Money Market Face Value/Unit",
    align: "right",
  },
  {
    label: "Total Face Value",
    align: "right",
  },
  {
    label: "Units",
    align: "right",
  },
  {
    label: "Avg Cost/Unit",
    align: "right",
  },
  {
    label: "Total Cost / Amount",
    align: "right",
  },
  {
    label: "Market Rate/Unit",
    align: "right",
  },
  {
    label: "Market Value",
    align: "right",
  },
  {
    label: "Unrealized Gain/(Loss)",
    align: "right",
  },
  {
    label: "Investment as % of Market Value",
    align: "right",
  },
];

export const newTXNType = [
  {
    value: "zakatondividend",
    label: "ZAKAT ON DIVIDEND",
  },
  {
    value: "zakatonbonusencashment",
    label: "ZAKAT ON BONUS ENCASHMENT",
  },
  {
    value: "cgtrefund",
    label: "CGT REFUND",
  },
  {
    value: "cgtonredemption",
    label: "CGT ON REDEMPTION",
  },
  {
    value: "cgtontransfer",
    label: "CGT ON TRANSFER",
  },
  {
    value: "cgtonconversionout",
    label: "CGT ON CONVERSION OUT",
  },
  {
    value: "cgtonconversion",
    label: "CGT ON CONVERSION",
  },
  {
    value: "refundofcapital",
    label: "REFUND OF CAPITAL",
  },
  {
    value: "taxabledividend",
    label: "TAXABLE DIVIDEND",
  },
  {
    value: "dividendreinvestment",
    label: "DIVIDEND REINVESTMENT",
  },
  {
    value: "dividendpaid",
    label: "DIVIDEND PAID",
  },
  {
    value: "taxondividend",
    label: "TAX ON DIVIDEND",
  },
  {
    value: "dividend",
    label: "DIVIDEND",
  },
  {
    value: "taxonbonusencashment",
    label: "TAX ON BONUS ENCASHMENT",
  },
  {
    value: "bonusencashment",
    label: "BONUS ENCASHMENT",
  },
  {
    value: "bonus",
    label: "BONUS",
  },
  {
    value: "transferlienin",
    label: "TRANSFER LIEN IN",
  },
  {
    value: "transferlienout",
    label: "TRANSFER LIEN OUT",
  },
  {
    value: "transferin",
    label: "TRANSFER IN",
  },
  {
    value: "transferout",
    label: "TRANSFER OUT",
  },
];

export const processDisbursementTabs = [
  "All",
  "Paid",
  "Reinvest",
  "Pending",
  // "Failed",
];

export const modeOfPaymentTypes = [
  "cheque",
  "online",
  "ift",
  "ibft",
  "rtgs",
  "po/dd",
];

export const MoneyMarketHeadings = [
  { label: "Symbol", align: "left" },
  { label: "Security Type", align: "left" },
  { label: "Name", align: "left" },
  { label: "Issue Date", align: "center" },
  { label: "Maturity Date", align: "center" },
  { label: "Coupon Rate %", align: "right" },
  { label: "Yield %", align: "right" },
  { label: "Money Market Face Value/Unit", align: "right" },
  { label: "Total Face Value", align: "right" },
  { label: "Units", align: "right" },
  { label: "Avg Cost/Unit", align: "right" },
  { label: "Total Cost / Amount", align: "right" },
  { label: "Market Rate/Unit", align: "right" },
  { label: "Market Value", align: "right" },
  { label: "Unrealized Gain/(Loss)", align: "right" },
  { label: "Investment as % of Market Value", align: "right" },
];

export const companyArr = [
  {
    label: "AUTOMOBILE ASSEMBLER",
    value: "0801",
  },
  {
    label: "AUTOMOBILE PARTS & ACCESSORIES",
    value: "0802",
  },
  {
    label: "CABLE & ELECTRICAL GOODS",
    value: "0803",
  },
  {
    label: "CEMENT",
    value: "0804",
  },
  {
    label: "CHEMICAL",
    value: "0805",
  },
  {
    label: "CLOSE - END MUTUAL FUND",
    value: "0806",
  },
  {
    label: "COMMERCIAL BANKS",
    value: "0807",
  },
  {
    label: "ENGINEERING",
    value: "0808",
  },
  {
    label: "FERTILIZER",
    value: "0809",
  },
  {
    label: "FOOD & PERSONAL CARE PRODUCTS",
    value: "0810",
  },
  {
    label: "GLASS & CERAMICS",
    value: "0811",
  },
  {
    label: "INSURANCE",
    value: "0812",
  },
  {
    label: "INV. BANKS / INV. COS. / SECURITIES COS.",
    value: "0813",
  },
  {
    label: "JUTE",
    value: "0814",
  },
  {
    label: "LEASING COMPANIES",
    value: "0815",
  },
  {
    label: "LEATHER & TANNERIES",
    value: "0816",
  },
  {
    label: "MISCELLANEOUS",
    value: "0818",
  },
  {
    label: "MODARABAS",
    value: "0819",
  },
  {
    label: "OIL & GAS EXPLORATION COMPANIES",
    value: "0820",
  },
  {
    label: "OIL & GAS MARKETING COMPANIES",
    value: "0821",
  },
  {
    label: "PAPER, BOARD & PACKAGING",
    value: "0822",
  },
  {
    label: "PHARMACEUTICALS",
    value: "0823",
  },
  {
    label: "POWER GENERATION & DISTRIBUTION",
    value: "0824",
  },
  {
    label: "REFINERY",
    value: "0825",
  },
  {
    label: "SUGAR & ALLIED INDUSTRIES",
    value: "0826",
  },
  {
    label: "SYNTHETIC & RAYON",
    value: "0827",
  },
  {
    label: "TECHNOLOGY & COMMUNICATION",
    value: "0828",
  },
  {
    label: "TEXTILE COMPOSITE",
    value: "0829",
  },
  {
    label: "TEXTILE SPINNING",
    value: "0830",
  },
  {
    label: "TEXTILE WEAVING",
    value: "0831",
  },
  {
    label: "TOBACCO",
    value: "0832",
  },
  {
    label: "TRANSPORT",
    value: "0833",
  },
  {
    label: "VANASPATI & ALLIED INDUSTRIES",
    value: "0834",
  },
  {
    label: "WOOLLEN",
    value: "0835",
  },
  {
    label: "REAL ESTATE INVESTMENT TRUST",
    value: "0836",
  },
  {
    label: "EXCHANGE TRADED FUNDS",
    value: "0837",
  },
  {
    label: "PROPERTY",
    value: "0838",
  },
];

export const sectorCodeArr = [
  {
    value: "0801",
    label: "0801",
  },
  {
    value: "0802",
    label: "0802",
  },
  {
    value: "0803",
    label: "0803",
  },
  {
    value: "0804",
    label: "0804",
  },
  {
    value: "0805",
    label: "0805",
  },
  {
    value: "0806",
    label: "0806",
  },
  {
    value: "0807",
    label: "0807",
  },
  {
    value: "0808",
    label: "0808",
  },
  {
    value: "0809",
    label: "0809",
  },
  {
    value: "0810",
    label: "0810",
  },
  {
    value: "0811",
    label: "0811",
  },
  {
    value: "0812",
    label: "0812",
  },
  {
    value: "0813",
    label: "0813",
  },
  {
    value: "0814",
    label: "0814",
  },
  {
    value: "0815",
    label: "0815",
  },
  {
    value: "0816",
    label: "0816",
  },
  {
    value: "0818",
    label: "0818",
  },
  {
    value: "0819",
    label: "0819",
  },
  {
    value: "0820",
    label: "0820",
  },
  {
    value: "0821",
    label: "0821",
  },
  {
    value: "0822",
    label: "0822",
  },
  {
    value: "0823",
    label: "0823",
  },
  {
    value: "0824",
    label: "0824",
  },
  {
    value: "0825",
    label: "0825",
  },
  {
    value: "0826",
    label: "0826",
  },
  {
    value: "0827",
    label: "0827",
  },
  {
    value: "0828",
    label: "0828",
  },
  {
    value: "0829",
    label: "0829",
  },
  {
    value: "0830",
    label: "0830",
  },
  {
    value: "0831",
    label: "0831",
  },
  {
    value: "0832",
    label: "0832",
  },
  {
    value: "0833",
    label: "0833",
  },
  {
    value: "0834",
    label: "0834",
  },
  {
    value: "0835",
    label: "0835",
  },
  {
    value: "0836",
    label: "0836",
  },
  {
    value: "0838",
    label: "0838",
  },
];

export const EquitySecuritiesArr = [
  {
    label: "AUTOMOBILE ASSEMBLER",
    value: "0801",
  },
  {
    label: "AUTOMOBILE PARTS & ACCESSORIES",
    value: "0802",
  },
  {
    label: "CABLE & ELECTRICAL GOODS",
    value: "0803",
  },
  {
    label: "CEMENT",
    value: "0804",
  },
  {
    label: "CHEMICAL",
    value: "0805",
  },
  {
    label: "CLOSE - END MUTUAL FUND",
    value: "0806",
  },
  {
    label: "COMMERCIAL BANKS",
    value: "0807",
  },
  {
    label: "ENGINEERING",
    value: "0808",
  },
  {
    label: "FERTILIZER",
    value: "0809",
  },
  {
    label: "FOOD & PERSONAL CARE PRODUCTS",
    value: "0810",
  },
  {
    label: "GLASS & CERAMICS",
    value: "0811",
  },
  {
    label: "INSURANCE",
    value: "0812",
  },
  {
    label: "INV. BANKS / INV. COS. / SECURITIES COS.",
    value: "0813",
  },
  {
    label: "JUTE",
    value: "0814",
  },
  {
    label: "LEASING COMPANIES",
    value: "0815",
  },
  {
    label: "LEATHER & TANNERIES",
    value: "0816",
  },
  {
    label: "MISCELLANEOUS",
    value: "0818",
  },
  {
    label: "MODARABAS",
    value: "0819",
  },
  {
    label: "OIL & GAS EXPLORATION COMPANIES",
    value: "0820",
  },
  {
    label: "OIL & GAS MARKETING COMPANIES",
    value: "0821",
  },
  {
    label: "PAPER, BOARD & PACKAGING",
    value: "0822",
  },
  {
    label: "PHARMACEUTICALS",
    value: "0823",
  },
  {
    label: "POWER GENERATION & DISTRIBUTION",
    value: "0824",
  },
  {
    label: "REFINERY",
    value: "0825",
  },
  {
    label: "SUGAR & ALLIED INDUSTRIES",
    value: "0826",
  },
  {
    label: "SYNTHETIC & RAYON",
    value: "0827",
  },
  {
    label: "TECHNOLOGY & COMMUNICATION",
    value: "0828",
  },
  {
    label: "TEXTILE COMPOSITE",
    value: "0829",
  },
  {
    label: "TEXTILE SPINNING",
    value: "0830",
  },
  {
    label: "TEXTILE WEAVING",
    value: "0831",
  },
  {
    label: "TOBACCO",
    value: "0832",
  },
  {
    label: "TRANSPORT",
    value: "0833",
  },
  {
    label: "VANASPATI & ALLIED INDUSTRIES",
    value: "0834",
  },
  {
    label: "WOOLLEN",
    value: "0835",
  },
  {
    label: "REAL ESTATE INVESTMENT TRUST",
    value: "0836",
  },
  {
    label: "EXCHANGE TRADED FUNDS",
    value: "0837",
  },
  {
    label: "PROPERTY",
    value: "0838",
  },
];

export const SecurityArr = [
  { label: "Money Market", value: "money_market" },
  { label: "Stock Market", value: "stock_market" },
];

export const pf_profit_inputs = [
  "Conventional Investment",
  "Islamic Investment",
];

export const vpsTxnStatus = ["investment", "withdrawal", "changeofallocation"];
